import { segmentTrack } from '$utils/handleSegment';
import classes from './Home.module.css';

const SPKBanner = () => {
  const tryNowClickHandler = () => {
    segmentTrack('SPK Banner Click');
  };

  return (
    <a
      href={`${process.env.REACT_APP_SPK_URL}/auth/signin`}
      target="_blank"
      onClick={tryNowClickHandler}
      rel="noreferrer"
    >
      <div
        className={`${classes.content} ${classes.profileContent} !top-0 bg-spk-banner-background text-white !justify-start !-mb-4 text-sm`}
      >
        <div className="py-4 flex flex-row justify-between w-full items-center gap-4">
          <div className="text-white font-bold ">
            Generate your{' '}
            <span className="text-spk-banner-highlightText">
              Simera Professional Key
            </span>{' '}
            and get real time support from our AI Career Coach Era.
          </div>
          <span className="bg-spk-banner-cta-background rounded px-2 py-1 text-xs text-spk-banner-cta-text font-semibold whitespace-nowrap">
            Login Here
          </span>
        </div>
      </div>
    </a>
  );
};

export default SPKBanner;
